export default __webpack_public_path__ + "cd228c198cc5609bf0d977874e494a38.ttf";